<template>
  <div class="new-goods">
    <DefTitle :result="1" :center="true">
      <h2>{{ result.message.title }}</h2>
    </DefTitle>

    <div class="new-goods-tabs">
      <span
        v-for="tab in saveData.tabs"
        :key="tab.id"
        class="new-goods-tabs__item"
        :class="{ 'new-goods-tabs__item_active': tab.active }"
        @click="handlerChangeTab(tab)"
      >
        {{ tab.name }}
      </span>
    </div>
    <DefSwiper :settings="settings" @swiper="swiper = $event">
      <SwiperSlide
        v-for="item in getActiveProducts"
        :key="(item?.offer && item?.offer?.id) || item?.id"
      >
        <SliderCard :result="item" />
      </SwiperSlide>

      <SwiperSlide class="swiper-slide__all-card">
        <div class="all-card">
          <DefLink :href="activeTab?.href || activeTab?.detailPage">
            {{ saveData?.message?.showAll?.name }}
            <svg class="all-card__icon">
              <use xlink:href="#svg-arrow-right"></use>
            </svg>
          </DefLink>
        </div>
      </SwiperSlide>
    </DefSwiper>
    <SliderAllButton v-if="result?.message?.showAll" :href="result.message.showAll?.href">
      {{ result.message.showAll?.name }}
    </SliderAllButton>
  </div>
</template>

<script>
import { SwiperSlide } from 'swiper/vue';
import { screenWidth } from '@use/useDeviceInfo';

import DefLink from '@components/Def/DefLink/DefLink.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefSwiper from '@components/Def/DefSwiper/DefSwiper.vue';
import SliderCard from '@components/card/SliderCard/SliderCard.vue';
import SliderAllButton from '@components/sliders/SliderAllButton.vue';

export default {
  name: 'NewGoods',
  components: {
    SliderAllButton,
    DefSwiper,
    DefTitle,
    SliderCard,
    DefLink,
    SwiperSlide,
  },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      saveData: this.result,
      screenWidth,
      swiper: null,
      settings: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 4,

        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 4,
            slidesPerGroup: 3,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 4,
            slidesPerGroup: 4,
          },
        },
      },
    };
  },
  computed: {
    activeTab() {
      return this.saveData?.tabs?.find((el) => el.active);
    },
    getActiveProducts() {
      if (this.activeTab?.id !== 0) {
        return this.saveData.items.filter((el) => el.sectionID == this.activeTab?.id);
      }
      return this.saveData.items;
    },
  },
  methods: {
    async handlerChangeTab(tab) {
      this.saveData.tabs = this.saveData.tabs.map((el) => ({
        ...el,
        active: tab.id == el.id,
      }));

      this.swiper?.slideTo(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.new-goods {
  margin-bottom: 56px;
  @include point-md {
    margin-bottom: 80px;
  }
  @include point-lg {
    margin-bottom: 100px;
  }
  :deep(.swiper-pagination) {
    margin-top: 24px;
  }
}
.new-goods-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1.12px;
  text-transform: uppercase;
  color: var(--color-dark-grey);
  @include point-md {
    margin-bottom: 8px;
    font-size: 16px;
  }
  @include point-lg {
    margin-bottom: 16px;
    letter-spacing: 1.28px;
  }
  &__item {
    cursor: pointer;
    transition: 0.2s linear color;
    margin-bottom: 16px;
    &:not(:last-child) {
      margin-right: 24px;
      @include point-md {
        margin-right: 21px;
      }
    }
    &_active {
      color: var(--text-colour-primary);
    }
  }
}
.all-card {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: white;
  &__icon {
    width: 24px;
    height: 24px;
    fill: currentColor;
  }
  :deep(.def-link) {
    display: flex;
    align-items: center;
    text-transform: uppercase;
  }
}
.swiper-slide__all-card {
  height: auto;
}
</style>
